import { useRef } from "react";

export function useFormRef() {
  const textFieldRef = useRef<any>({});
  async function validate() {
    let validate = true;
    for (const key in textFieldRef.current) {
      let result = await textFieldRef.current[key]?.validate();
      if (!result) validate = false;
    }
    return validate;
  }
  return { validate, textFieldRef };
}
